import HeaderImage from "../HeaderImage/ui/HeaderImage";
import HeaderLinks from "../HeaderLinks/HeaderLinks";
import styles from './HeaderMain.module.scss';
import { Text } from "../../../../shared/ui/Text/Text";
import { Stack } from "../../../../shared/ui/Stack/Stack";

const HeaderMain = () => {
    return ( 
        <div className={styles.header}>
            <HeaderLinks/>
            <div className={styles.container}>
                <div className={styles.context}>                
                    <Text type='h2' size = 'xxl' className={styles.title}>
                        ФОТОГРАФИРУЮ ДУШУ ЧЕРЕЗ ТЕЛО...
                    </Text>               
                <Stack 
                    direction='column'
                    gap= '16'
                    className={styles.text__container}>
                        <Text 
                        type='h2' 
                        size = 'xl' 
                        className={styles.text__color}>
                            Проявление души...
                            </Text>
                        <Text 
                        type='h2' 
                        size = 'xl' 
                        className={styles.text}>
                            В  эмоциях, взгляде, улыбках, объятиях, смехе, в искорках счастья в глазах.
                            </Text>
                </Stack>  
                </div>
                <HeaderImage/>
            </div>           
        </div>
     );
}
 
export default HeaderMain;